// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardDetails button {
    border-radius: 5px;
    padding: 0.375rem 0.75rem;
    border: none;
    color: white;
    background: #1f92b5;
    width: 100% !important;
    height: 35px;
    margin-bottom: 10px;
    font-weight: 300;
    font-size: 14px;
    margin-top: 30px;
    font-family: 'Poppins';
    display: inline-block;
    text-decoration: none;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/dashboard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;AACtB","sourcesContent":[".cardDetails button {\n    border-radius: 5px;\n    padding: 0.375rem 0.75rem;\n    border: none;\n    color: white;\n    background: #1f92b5;\n    width: 100% !important;\n    height: 35px;\n    margin-bottom: 10px;\n    font-weight: 300;\n    font-size: 14px;\n    margin-top: 30px;\n    font-family: 'Poppins';\n    display: inline-block;\n    text-decoration: none;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
